import React from 'react';
import { useFooter } from '../../hooks/useFooter';
import styles from './Footer.module.css';

const Footer = () => {
    const { currentYear } = useFooter();

    return (
        <footer className={styles.footer}>
            <div className={styles.separator} />
            <div className={styles.content}>
                <span className={styles.copyrightYear}>{currentYear} ©</span>
                <span className={styles.brand}>Waitlist</span>
            </div>
        </footer>
    );
};

export default Footer;